'use client';
import * as React from 'react';
import { cn } from '@/lib/shared/ui';

type Props = {
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
};

export const GradientBlock = (props: Props) => {
  const { children, className, overlayClassName } = props;

  const [opacity, setOpacity] = React.useState(1);
  const node = React.useRef<HTMLDivElement>(null);
  const updatingFromScroll = React.useRef(false);

  const handleScroll = () => {
    if (!updatingFromScroll.current) {
      requestAnimationFrame(updateFromScroll);
      updatingFromScroll.current = true;
    }
  };

  const updateFromScroll = () => {
    if (!node || node.current == null) {
      return;
    }

    const position =
      (node.current.offsetTop + node.current.offsetHeight / 2 - window.scrollY) /
      window.innerHeight;

    const currentOpacity =
      position > 0 && position < 1 ? (Math.sin(2 * Math.PI * position - Math.PI / 2) + 1) / 2 : 0;

    if (currentOpacity !== opacity) {
      setOpacity(currentOpacity);
    }

    updatingFromScroll.current = false;
  };

  React.useEffect(() => {
    if (window) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={cn('bg-primary/[0.15] rounded relative', className)} ref={node}>
      <div
        className={cn(
          'bg-linear-to-t from-[rgba(9,45,165,0)] rounded to-[#1f40dd] absolute w-full h-full z-1',
          overlayClassName,
        )}
        style={{ opacity }}
      />
      {children}
    </div>
  );
};

// linear-gradient(0deg,rgba(9,45,165,0),#1f40dd)
